export const TABS = {
  INGRESAR_PRESTACIONES: 'ingresarPrestaciones',
  PRESTACIONES: 'prestaciones',
  REPORTE: 'reporte',
  ELEGIBILIDAD: 'elegibilidad',
};
